import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { tv } from "tailwind-variants";
import cn from "../../utils/cn";
const tagVariants = tv({
    base: "inline-block items-center whitespace-nowrap justify-center rounded-2xl w-auto bg-white text-xs font-medium border border-transparent",
    variants: {
        size: {
            condensed: "px-2.5 py-1",
            default: "px-2.5 py-2",
        },
        color: {
            default: "text-gray-10",
            primary: "text-primary",
            success: "text-success",
            danger: "text-danger",
            warning: "text-warning",
            purple: "text-accessory-purple",
            sky: "text-accessory-sky",
            "danger-dark": "text-danger",
        },
        variant: {
            default: "bg-gray-2 text-gray-10",
            contained: "bg-gray-4",
            outlined: "border border-gray-4",
            surface: "",
        },
    },
    compoundVariants: [
        //-=-=-== CONTAINED -=-=-=-=
        {
            variant: "contained",
            color: "default",
            className: "bg-gray-dark text-white",
        },
        {
            variant: "contained",
            color: "primary",
            className: "bg-primary text-white",
        },
        {
            variant: "contained",
            color: "success",
            className: "bg-success text-white",
        },
        {
            variant: "contained",
            color: "danger",
            className: "bg-danger text-white",
        },
        {
            variant: "contained",
            color: "warning",
            className: "bg-warning text-white",
        },
        {
            variant: "contained",
            color: "danger-dark",
            className: "bg-danger-11 text-white",
        },
        {
            variant: "contained",
            color: "purple",
            className: "bg-accessory-purple-10 text-white",
        },
        {
            variant: "contained",
            color: "sky",
            className: "bg-accessory-sky-10 text-white",
        },
        // -=-=-=-= SURFACE -=-=-=-=
        {
            variant: "surface",
            color: "default",
            className: "bg-gray-3 text-gray-11",
        },
        {
            variant: "surface",
            color: "primary",
            className: "bg-primary-3 text-primary-11",
        },
        {
            variant: "surface",
            color: "success",
            className: "bg-success-3 text-success-11",
        },
        {
            variant: "surface",
            color: "danger",
            className: "bg-danger-3 text-danger-11",
        },
        {
            variant: "surface",
            color: "warning",
            className: "bg-warning-3 text-warning-11",
        },
        {
            variant: "surface",
            color: "danger-dark",
            className: "bg-danger-3 text-danger-11",
        },
        {
            variant: "surface",
            color: "purple",
            className: "bg-accessory-purple-3 text-accessory-purple-11",
        },
        {
            variant: "surface",
            color: "sky",
            className: "bg-accessory-sky-3 text-accessory-sky-11",
        },
        // -=-=-=-= OUTLINE -=-=-=-=
        {
            variant: "outlined",
            color: "default",
            className: "border-gray-light text-gray-dark",
        },
        {
            variant: "outlined",
            color: "primary",
            className: "border-primary text-primary",
        },
        {
            variant: "outlined",
            color: "success",
            className: "border-success text-success",
        },
        {
            variant: "outlined",
            color: "danger",
            className: "border-danger text-danger",
        },
        {
            variant: "outlined",
            color: "warning",
            className: "border-warning text-warning",
        },
        {
            variant: "outlined",
            color: "danger-dark",
            className: "border-danger-10 text-danger-10",
        },
        {
            variant: "outlined",
            color: "purple",
            className: "border-accessory-purple text-accessory-purple",
        },
        {
            variant: "outlined",
            color: "sky",
            className: "border-accessory-sky-11 text-accessory-sky-11",
        },
    ],
    defaultVariants: {
        color: "default",
        size: "default",
        variant: "default",
    },
});
const customIcon = (icon, color, variant) => {
    return React.cloneElement(icon, {
        className: cn(variant === "default" && {
            "text-gray-dark": color === "default",
            "text-primary": color === "primary",
            "text-success": color === "success",
            "text-danger": color === "danger",
            "text-warning": color === "warning",
            "text-danger-dark": color === "danger-dark",
            "text-accessory-purple": color === "purple",
            "text-accessory-sky-11": color === "sky",
        }),
    });
};
const Tag = ({ className, variant, color, label, icon, size, ...props }) => {
    return (_jsx("div", { className: cn(tagVariants({ variant, className, color, size })), ...props, children: _jsxs("div", { className: "flex items-center gap-2 leading-100", children: [icon ? customIcon(icon, color, variant) : null, label] }) }));
};
Tag.displayName = "Tag";
export default Tag;
